import { Link } from "react-router-dom";
import type { Streamer } from "@/types/content";

interface ProfileHeroProps {
  streamer: Streamer;
}

export default function ProfileHero({ streamer }: ProfileHeroProps) {
  return (
    <div className="relative w-full rounded-lg overflow-hidden bg-foreground-950">
      <img
        src={streamer.cover}
        alt={`${streamer.name} 封面`}
        title={`${streamer.name} 韩国女主播`}
        className="absolute inset-0 w-full h-full object-cover object-top opacity-70"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/90 via-foreground-950/55 to-foreground-950/40"></div>

      <div className="relative flex flex-col md:flex-row items-start md:items-end gap-5 p-6 md:p-8">
        <div className="w-28 h-36 md:w-36 md:h-48 shrink-0 rounded-lg overflow-hidden border-2 border-background-50/30 bg-background-100">
          <img
            src={streamer.avatar}
            alt={`${streamer.name} 头像`}
            title={`${streamer.name} 韩国女主播`}
            className="w-full h-full object-cover object-top"
          />
        </div>

        <div className="flex-1 min-w-0">
          <div className="flex flex-wrap items-center gap-2 mb-2">
            <span className="px-3 py-1 rounded-full text-xs font-medium bg-accent-500 text-background-50">
              {streamer.type}
            </span>
            <span className="px-3 py-1 rounded-full text-xs font-medium bg-background-50/20 text-background-50">
              {streamer.region}
            </span>
          </div>
          <h1 className="text-2xl md:text-4xl font-heading font-bold text-background-50 leading-tight">
            {streamer.name}
          </h1>
          <p className="text-background-200/90 text-sm mt-1">{streamer.nameEn}</p>
          <p className="text-background-100 text-sm mt-2 flex items-center gap-1.5">
            <i className="ri-tv-2-line text-accent-400"></i>
            {streamer.position} · {streamer.program}
          </p>
          <p className="hidden md:block text-sm text-background-200/85 leading-relaxed mt-3 max-w-2xl">
            {streamer.bio}
          </p>
          <div className="flex flex-wrap gap-2 mt-4">
            {streamer.tags.map((tag) => (
              <span key={tag} className="px-2.5 py-1 rounded-full text-xs bg-background-50/15 text-background-100">
                #{tag}
              </span>
            ))}
          </div>
        </div>

        <div className="w-full md:w-auto flex md:flex-col gap-3">
          <button
            type="button"
            className="flex-1 md:flex-none inline-flex items-center justify-center gap-1.5 px-5 py-2.5 rounded-md bg-accent-500 text-background-50 text-sm font-medium hover:bg-accent-600 transition-colors cursor-pointer whitespace-nowrap"
          >
            <i className="ri-heart-add-line"></i>
            关注主播
          </button>
          <Link
            to="/category"
            className="flex-1 md:flex-none inline-flex items-center justify-center gap-1.5 px-5 py-2.5 rounded-md bg-background-50/20 text-background-50 text-sm font-medium hover:bg-background-50/30 transition-colors whitespace-nowrap"
          >
            <i className="ri-arrow-left-line"></i>
            返回分类
          </Link>
        </div>
      </div>
    </div>
  );
}